module.exports = "/static/images/upstairs-logo-color.svg";